import { useQueryParams } from '@m/hooks/useQueryParams';
import { useStoreRwgReferral } from '@m/hooks/useStoreRwgReferral';

import { RWG_CONFIG } from '../../services/rwgConfig';

function firstValue(param: string | (string | null)[] | null): string | undefined {
  const value = Array.isArray(param) ? param[0] : param;
  return value ?? undefined;
}

/**
 * Captures the Reserve with Google `rwg_token` from the landing URL. Mounted at the app root so
 * any route an RwG link lands on captures it. The `zone` param is forwarded by the marketing
 * app's proxy when marketing pages are disabled.
 *
 * Mirrors the marketing app's component of the same name; both delegate to `useStoreRwgReferral`
 * and differ only in which router they read the params from.
 */
export function CaptureRwgToken() {
  const [queryParams] = useQueryParams();

  useStoreRwgReferral(firstValue(queryParams.rwg_token), firstValue(queryParams.zone), RWG_CONFIG);

  return null;
}
